import { applyMiddleware, createStore, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise'
import { createLogger } from 'redux-logger'
import appReducer from './reducers/index'

const logger = createLogger()

const reducer = combineReducers({
  app: appReducer
})

const store = createStore(reducer, applyMiddleware(thunk, promise, logger))

export default store



// WEBPACK FOOTER //
// ./src/store.js